import { Tag } from '@innovationnorway/cl-react';
import { MainAndSupportColors, SeverityColors } from '@innovationnorway/cl-react/dist/types/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SivaPhase } from 'src/api/v2';

type Props = {
  phase: SivaPhase | '' | undefined;
};

const types: Record<SivaPhase, 'neutral' | keyof MainAndSupportColors | SeverityColors> = {
  [SivaPhase.Idea]: 'info', // blue
  [SivaPhase.PreIncubation]: 'info', // blue
  [SivaPhase.Incubated]: 'info', // blue
  [SivaPhase.Fi]: 'info', // blue
  [SivaPhase.ScaleUp]: 'info', // blue
  [SivaPhase.Alumni]: 'neutral', // gray
  [SivaPhase.Targeted]: 'info', // blue
};

const SivaPhaseTag: React.FC<Props> = ({ phase }) => {
  const { t: tSiva } = useTranslation('siva');

  if (!phase) {
    return null;
  }

  const type = types[phase] ?? 'neutral';
  const text = tSiva(`phase.${phase}` as any, {
    defaultValue: phase,
  });

  return <Tag data-color={type}>{text}</Tag>;
};

export default SivaPhaseTag;
